<template>
  <div class="datepicker-container display-flex align-center justify-between pos-rel pl0-625">
    <template>
      <v-text-field
        class="w40p pos-rel mr2"
        :value="dateRangeText"
        label="Select Date Range (Start Date & End Date)"
        :disabled="disabled"
        readonly
        @click="toggleDatePicker"
      />
      <bh-button
        v-if="dates.length"
        :disabled="disabled"
        btnClass="w20p bg-violet text-white border-none br0-5 f1-5 pa1 mr1"
        @output="resetDateRange()"
        >
        Reset
      </bh-button>
    </template>
    <v-date-picker
      v-if="open"
      v-model="dates"
      :range="range"
      :disabled="disabled"
      no-title
    >
      <v-spacer />
      <v-btn text color="primary" @click="closeDaterangePicker">Cancel</v-btn>
      <v-btn outlined color="primary" @click="onDateRangeSelect">OK</v-btn>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  name: 'bh-daterange',
  props: {
    dateRange: {
      type: Array,
      default() {
        return []
      }
    },
    range: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dates: [],
      open: false,
      isDatePickerApplied: false
    }
  },
  mounted() {
    this.dates = this.dateRange
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' & ')
    }
  },
  methods: {
    onDateRangeSelect() {
      this.dates.sort()
      this.$emit('onDateRangeSelect', this.dates)
      this.open = false
      this.isDatePickerApplied = true
    },
    toggleDatePicker() {
      this.open = !this.open
    },
    closeDaterangePicker() {
      if (!this.isDatePickerApplied) {
        this.dates = []
      }
      this.open = false
    },
    resetDateRange() {
      this.dates = []
      this.isDatePickerApplied = false
      this.$emit('resetDateRange', true)
    }
  }
}
</script>

<style>
.datepicker-container .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  left: 10px;
  top: 50px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  transform-origin: left top;
  z-index: 8;
}

.datepicker-container .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #5664b3;
}

.datepicker-container .v-date-picker-header__value {
  font-size: 16px;
}

.datepicker-container .v-card__actions > .v-btn.v-btn {
  font-size: 10px;
}

.v-date-picker-table .v-btn.v-btn--active {
  background-color: #5664b3;
}

.datepicker-container .v-text-field .v-label--active {
  transform: translate(-43px, -18px)scale(.75);
}
</style>
